<template>
  <div class="">
    <div class="bg-tile text-white  p-2">
      <vk-modal-close outside @click="modalClose()"></vk-modal-close>
      <h2 class="text-white p-0 m-0">
        {{ header }}
      </h2>
    </div>
    <div class="w-full  text-sm p-4">
      <form
        method="post"
        action="javascript:void(0)"
        @submit.prevent="saveForm()"
      >
        <div class="uk-margin" :key="input" v-for="input in inputs">
          <form-item
            :label="true"
            v-if="input.show_insert == 1"
            :form="form"
            :input="input"
            @changed="(gelen) => receivedData(gelen)"
            :type="input.component.name"
          />
        </div>
        <div slot="footer">
          <div class="flex space-x-2 items-center">
            <span class="global-button" type="reset" @click="modalClose()">
              İptal
            </span>
            <savebutton action="addItem" title="Kaydet" />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import HttpService from "../../services/http";
import EventBus from "./EventBus";
export default {
  name: "add-item",
  props: {
    header: String,
    inputs: Array | Object,
    table: String,
    showType: {
      default: "panel",
    },
  },
  components: {
    "form-item": () => {
      return import("./FormItem.vue");
    },
  },
  data() {
    return {
      form: {},
      edit: false,
      type: "insert",
    };
  },
  created() {},
  methods: {
    modalClose() {
      this.$emit("after", "success");
    },
    receivedData(data) {
      this.form[data.name] = data.value;
    },
    saveForm() {
      EventBus.$emit("loadingStatus", { action: "addItem", loading: true });

      HttpService.inlineSave({
        table: this.table,
        type: this.type,
        inputs: this.form,
      })
        .then((resp) => {
          if (resp.data.success) {
            this.edit = false;
            this.form = {};
            EventBus.$emit("loadingStatus", {
              action: "addItem",
              loading: false,
              success: true,
            });

            this.$emit("after", "success");
          } else {
            EventBus.$emit("loadingStatus", {
              action: "addItem",
              loading: false,
              success: false,
            });
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz.("+resp.data.message+")"
            );
            this.$emit("after", "success");
          }
        })
        .catch((e) => {
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
        });
    },
  },
};
</script>
